import React from "react";
import PropTypes from "prop-types";

import styles from "./Footnote.scss";

// TODO
// eslint-disable-next-line react/prefer-stateless-function
class FootnoteList extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  static defaultProps = {};

  static displayName = "Footnotes.List";

  render() {
    const { children } = this.props;

    return <ol className={styles.list}>{children}</ol>;
  }
}

export default FootnoteList;
